import { withDependencies } from '@wix/thunderbolt-ioc'
import { ITpaSrcUtility, PopupSrcControls, TpaSrcControls } from '../types'
import { createPromise } from '@wix/thunderbolt-commons'
import { IStructureAPI, StructureAPI } from '@wix/thunderbolt-symbols'

export const TpaSrcUtility = withDependencies(
	[StructureAPI],
	(structureApi: IStructureAPI): ITpaSrcUtility => {
		const { resolver, promise } = createPromise()
		const tpaControls: { [contextId: string]: TpaSrcControls } = {}
		const popupControls: { [pageId: string]: PopupSrcControls } = {}
		return {
			registerTpaControls(contextId, controls) {
				tpaControls[contextId] = controls
				resolver()
			},
			registerPopupControls(pageId, controls) {
				popupControls[pageId] = controls
			},
			async rebuildTpaSrc(compId) {
				await promise
				const contextId = structureApi.getContextIdOfCompId(compId)
				if (contextId) {
					tpaControls[contextId]?.rebuildTpaSrc(compId)
				}
			},
			async rebuildTpasSrc() {
				await promise
				Object.values(tpaControls).forEach(({ rebuildTpasSrc }) => {
					rebuildTpasSrc()
				})
				Object.values(popupControls).forEach(({ refreshAllPopups }) => {
					refreshAllPopups()
				})
			},
		}
	}
)
